import Vue from 'vue';
import Router from 'vue-router';

import ContractChange from '@views/ContractChange';
import CreatePassword from '@views/CreatePassword';
import CreateShop from '@views/CreateShop';
import FillBillingInfo from '@views/FillBillingInfo';
import Onboarding from '@views/Onboarding';
import StepError from '@views/StepError';
import ValidateQuote from '@views/ValidateQuote';
import SuccessPage from '@/views/SuccessPage';

Vue.use(Router);

const routes = [
  {
    path: '/',
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: Onboarding,
    children: [
      {
        path: 'validate_quote',
        name: 'validateQuote',
        component: ValidateQuote,
      },
      {
        path: 'fill_billing_info',
        name: 'fillBillingInfo',
        component: FillBillingInfo,
      },
      {
        path: 'create_password',
        name: 'createPassword',
        component: CreatePassword,
      },
      {
        path: 'success_page',
        name: 'successPage',
        component: SuccessPage,
      },
      {
        path: 'error',
        name: 'error',
        component: StepError,
        props: true,
      },
    ],
  },
  {
    path: '/contract_change',
    name: 'contractChange',
    component: ContractChange,
    children: [
      {
        path: 'create_shop',
        name: 'createShop',
        component: CreateShop,
      },
      {
        path: 'success_page',
        name: 'successPage',
        component: SuccessPage,
      },
      {
        path: 'error',
        name: 'contractChangeError',
        component: StepError,
        props: true,
      },
    ],
  },
];

const router = new Router({
  mode: 'history',
  routes,
});

export default router;
